import moment from 'moment'
import 'moment-timezone';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TimezoneAbbreviations = {
    EST: 'Eastern Standard Time',
    EDT: 'Eastern Daylight Time',
    CST: 'Central Standard Time',
    CDT: 'Central Daylight Time',
    MST: 'Mountain Standard Time',
    MDT: 'Mountain Daylight Time',
    PST: 'Pacific Standard Time',
    PDT: 'Pacific Daylight Time',
    NST: 'Newfoundland Standard Time',
    NDT: 'Newfoundland Daylight Time',
    AST: 'Atlantic Standard Time',
    ADT: 'Atlantic Daylight Time',
    AKST: 'Alaska Standard Time',
    AKDT: 'Alaska Daylight Time',
    HAST: 'Hawaii-Aleutian Standard Time',
    HADT: 'Hawaii-Aleutian Daylight Time'
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WhiteListCities = ['New York City', 'New York', 'Los Angeles', 'Chicago', 'Dallas', 'Houston', 'Toronto',
    'Washington', 'Philadelphia', 'Miami', 'Atlanta', 'Boston', 'San Francisco', 'Phoenix',
    'Inland Empire', 'Monterrey', 'Newport Beach', 'Detroit', 'Montreal', 'Seattle', 'Minneapolis',
    'San Diego', 'Tampa Bay Area', 'Denver', 'St. Louis', 'Baltimore', 'Vancouver', 'Charlotte',
    'Portland', 'Orlando', 'San Antonio', 'Pittsburgh', 'Sacramento', 'Cincinnati', 'Las Vegas',
    'Kansas City', 'Cleveland', 'Columbus', 'Austin', 'Indianapolis', 'San Jose'];

export class TimeZoneDetectorService {

    guessTimezone(date, timeZoneOffset) {
        timeZoneOffset = timeZoneOffset * 60;
        const timestamp = moment(date).valueOf();
        const timezones = moment.tz.names()
            .filter(p => /(Canada|America)/.test(p))
            .reduce(function (zones, zoneName) {
                const zone = moment.tz.zone(zoneName);
                const offset = zone.parse(timestamp);
                if (-offset === timeZoneOffset) {
                    const abbr = zone.abbr(timestamp);
                    if (abbr) {
                        zones.push({
                            ZoneName: zoneName,
                            Offset: timeZoneOffset,
                            Abbr: TimezoneAbbreviations[abbr] || abbr
                        });
                    }
                }
                return zones;
            }, [])
            .filter(p => WhiteListCities.some(q => p.ZoneName.replace("_", " ").includes(q)));

        if (timezones.length > 0) {
            return timezones[0];
        }
    }

}
